import { FormikFormField } from './forms/FormikFormField'
import { Wizard } from './Wizard'

export const molecules = {
  FormikFormField,
  Wizard,
};

export default molecules;
